import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import dotenv from 'dotenv';

dotenv.config({ path: '.env' }); // Load environment variables from .env file

const getReturnUrl = (env) => {
  switch (env) {
    case 'production':
      return 'https://silhouetteandshadow.org/user/connect-paypal';
    case 'staging':
      return 'https://silhouetteandshadow-staging.herokuapp.com/user/connect-paypal';
    default:
      return 'http://localhost:3000/user/connect-paypal';
  }
};

export default class extends Controller {
  static values = { env: String };

  async connect_paypal(e) {
    e.preventDefault();

    const isProduction = this.envValue === 'production';

    const keySecret = `${process.env.PAYPAL_CLIENT_ID}:${process.env.PAYPAL_CLIENT_SECRET}`;

    console.log('keySecret: '+ keySecret);

    const res = await fetch(
      isProduction
        ? 'https://api-m.paypal.com/v1/oauth2/token'
        : 'https://api-m.sandbox.paypal.com/v1/oauth2/token',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${btoa(keySecret)}`,
        },
        body: [
          encodeURIComponent('grant_type') +
            '=' +
            encodeURIComponent('client_credentials'),
        ],
      }
    );
    const token = await res.json();

    const customer = await fetch(
      isProduction
        ? 'https://api-m.paypal.com/v2/customer/partner-referrals'
        : 'https://api-m.sandbox.paypal.com/v2/customer/partner-referrals',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.access_token}`,
        },
        body: JSON.stringify({
          operations: [
            {
              operation: 'API_INTEGRATION',
              api_integration_preference: {
                rest_api_integration: {
                  integration_method: 'PAYPAL',
                  integration_type: 'THIRD_PARTY',
                  third_party_details: {
                    features: ['PAYMENT', 'REFUND'],
                  },
                },
              },
            },
          ],
          products: ['EXPRESS_CHECKOUT'],
          legal_consents: [
            {
              type: 'SHARE_DATA_CONSENT',
              granted: true,
            },
          ],
          partner_config_override: {
            return_url: getReturnUrl(this.envValue),
          },
        }),
      }
    );

    const data = await customer.json();
    const { links } = data;

    console.log('Response from PayPal API:', data); // Log the response for debugging purposes

    if (links.length > 1) {
      window.open(
        `${links[1].href}&displayMode=minibrowser`,
        '_blank'
      ) || window.location.replace(`${links[1].href}&displayMode=minibrowser`);
    } else {
      console.error('Unexpected response from PayPal API');
    }
  }
}
